module.exports = __webpack_public_path__ + "static/media/solution-banner.194959a4.png";